import { Box, Button, Text } from '@nerdwallet/currency';
import React from 'react';
import Bookmark from '@nerdwallet/react-icon/nerdwallet-ui/Bookmark';
import styles from './save-button.module.less';

type SaveButtonProps = {
  onClick: () => void;
};

export const SaveButton: React.FC<SaveButtonProps> = ({ onClick }) => {
  return (
    <Button secondary className={styles.saveButton} onClick={onClick}>
      <Box display="flex" alignItems="center" gridGap={1}>
        <Bookmark size={30} />
        <Text>save article</Text>
      </Box>
    </Button>
  );
};
